
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ship-to-school",
      function () {
        return require("private-next-pages/ship-to-school/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ship-to-school"])
      });
    }
  